import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-water_bili_meter",
  "use": "icon-water_bili_meter-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-water_bili_meter\"><path d=\"M512 16c256 253.184 384 450.496 384 591.872a384 384 0 0 1-768 0C128 466.432 256 269.184 512 16z m33.984 126.208L512 106.816l-15.168 15.616C292.672 334.72 192 499.2 192 607.872a320 320 0 1 0 640 0c0-105.28-94.528-262.976-286.016-465.664z m-61.248 193.024l54.528 33.536L441.216 528h256l-157.952 256.768-54.528-33.536 97.92-159.232H326.72l158.08-256.768z\" p-id=\"72570\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/water_bili_meter.svg
// module id = xME7
// module chunks = 215